import type { FC } from 'react';

import { type Editor, EditorContent } from '@tiptap/react';
import cn from 'classnames';

import * as styles from '../../CommunityPostComposer.css';

interface ComposerEditorProps {
  editor: Editor | null;
  className?: string;
  minHeight?: number;
}

export const ComposerEditor: FC<ComposerEditorProps> = ({ editor, className, minHeight }) => (
  <div className={cn(styles.editorRoot, 'community-post-composer-editor flex flex-1 flex-col', className)}>
    <EditorContent
      editor={editor}
      className="flex flex-1 flex-col text-base leading-6 text-black"
      style={{ minHeight: minHeight ?? 200 }}
    />
  </div>
);
